



























































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import RangeSlider from "@/components/VRangeSliderStyling.vue";
import ColorPicker from '@/commonComponents/colorPicker/colorPicker.vue';
import DropdownList from "@/commonComponents/dropdownList/dropdownList.vue";

import * as def from "@/definitions";

import { PlainTextLayer } from "@/model/document2/page/surface/design/layer/plainTextLayer";
import { ColorConstruct } from "@/utilityModels/colorConstruct";

import ValueEdit from "@/commonComponents/valueEdit/valueEdit.vue";
import { TextInfo } from '@/utilityModels/textInfo';
import { MathHelper } from '@/helper/mathHelper';
import { FontManager } from '@/model/fontManager/fontManager';

import ColorSelector from "@/commonComponents/colorSelector/colorSelector.vue";
import FontSelector from "@/commonComponents/fontSelector/fontSelector.vue";
import AdjustedBalloon from '@/commonComponents/adjustedBalloon/adjustedBalloon.vue';

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import CheckBoxOn from "../resources/checkBoxOn.vue";
import RadioOn from "../resources/radioOn.vue";
import AlignLeftOn from "../resources/alignLeft_on.vue";
import AlignLeftOff from "../resources/alignLeft_off.vue";
import AlignCenterOn from "../resources/alignCenter_on.vue";
import AlignCenterOff from "../resources/alignCenter_off.vue";
import AlignRightOn from "../resources/alignRight_on.vue";
import AlignRightOff from "../resources/alignRight_off.vue";
import AlignEvenOn from "../resources/alignEven_on.vue";
import AlignEvenOff from "../resources/alignEven_off.vue";
import AlignTopOn from "../resources/alignTop_on.vue";
import AlignTopOff from "../resources/alignTop_off.vue";
import AlignMiddleOn from "../resources/alignMiddle_on.vue";
import AlignMiddleOff from "../resources/alignMiddle_off.vue";
import AlignBottomOn from "../resources/alignBottom_on.vue";
import AlignBottomOff from "../resources/alignBottom_off.vue";

import { ResourceHelper } from "@/helper/resourceHelper"

@Component({
  components: {
    RangeSlider,
    ColorPicker,
    ValueEdit,
    DropdownList,
    ColorSelector,
    FontSelector,
    AdjustedBalloon,

    ArrowDown,
    ArrowRight,
    CheckBoxOn,
    RadioOn,
    AlignLeftOn,
    AlignLeftOff,
    AlignCenterOn,
    AlignCenterOff,
    AlignRightOn,
    AlignRightOff,
    AlignEvenOn,
    AlignEvenOff,
    AlignTopOn,
    AlignTopOff,
    AlignMiddleOn,
    AlignMiddleOff,
    AlignBottomOn,
    AlignBottomOff
  }
})

// テキスト編集中かつ文字列非選択 / テキスト非選択中
// このとき、設定は文字列全てに反映する。
export default class PlainTextStyle extends Vue
{
    @Prop() private layer!: PlainTextLayer;

    private changeInputMode(mode)
    {
        this.$store.dispatch("changeInputMode", mode);
    }

    private onFocusInput()
    {
        this.changeInputMode(1);
    }

    // TextEditorのfocusLockを解除する
    private unlockTextEditorFocus()
    {
        // メッセージセンター取得
        var messageCenter = this.$store.getters.messageCenter;
        // メッセージセンターに送信
        messageCenter.send("unlock_text_editor_focus", null);
    }

    // カーソル位置を元にしたtextInfo
    private get currentTextInfo()
    {
        var indexPair = this.layer.getLineAndCharacterIndexFromPosition(this.layer.startPosition);
        var info = this.layer.getCharacterInfo(indexPair.lineIndex, indexPair.characterIndex);
        return info != null ? info.textInfo : this.layer.baseTextInfo;
    }

    private getCurrentValueInfo(propertyName)
    {
        // デフォルト値
        var defaultValue = this.layer.baseTextInfo[propertyName];
        // すべて値が同じフラグ
        var isSameAll = true;
        var value = defaultValue;

        for(var i = 0; i < this.layer.textInfoArray.length; ++i)
        {
            var textInfo = this.layer.textInfoArray[i];
            var newValue = textInfo[propertyName];
            if(i > 0 && !MathHelper.equals(newValue, value))
            {
                isSameAll = false;
                value = defaultValue;
                break;
            }
            value = newValue;
        }

        return { value : value, isBlank : !isSameAll };
    }

    private getCurrentColorInfo(propertyName)
    {
        // デフォルト値
        var defaultValue = this.layer.baseTextInfo[propertyName];
        // すべて値が同じフラグ
        var isSameAll = true;
        var value = defaultValue;

        for(var i = 0; i < this.layer.textInfoArray.length; ++i)
        {
            var textInfo = this.layer.textInfoArray[i];
            var newValue = textInfo[propertyName];
            if(i > 0 && !newValue.equals(value))
            {
                isSameAll = false;
                value = defaultValue;
                break;
            }
            value = newValue;
        }

        return { value : value, isBlank : !isSameAll };
    }

    isFontDropdownActive : boolean = false;
    private dropdownListVisibleChanged(isVisible : boolean)
    {
        this.isFontDropdownActive = isVisible;
    }
    private getFontManager() : FontManager
    {
        return this.$store.getters.fontManager;
    }
    private get selectedFontId() { return this.getCurrentFontId(); }
    private getCurrentFontId()
    {
        // 編集中はカレント位置から
        if(this.layer.inEdit) { return this.currentTextInfo.fontId; }
        // 非編集中
        // すべて同じ : そのid
        // それ以外 : null
        if(this.layer.textInfoArray.length == 0)
        {
            return this.layer.baseTextInfo.fontId;
        }
        else
        {
            var isSameAll = true;
            var defalutFontId = this.layer.baseTextInfo.fontId;
            for(var info of this.layer.textInfoArray)
            {
                if(info.fontId != defalutFontId)
                {
                    isSameAll = false;
                    break;
                }
            }
            return isSameAll ? defalutFontId : null;
        }
    }
    private onSelectFont(fontId: number)
    {
        this.changeTextInfo(fontId, "fontId", true, true);
    }

    private get textColor() { return this.layer.inEdit ? this.currentTextInfo.textColor : this.getCurrentColorInfo("textColor").value; }
    private get textColorStyle()
    {
        var isBlank = this.layer.inEdit ? false : this.getCurrentColorInfo("textColor").isBlank;
        return isBlank ? { "border-color" : "#000000", "border-width" : "1px", "border-style" : "solid" } : { "background-color" : this.textColor.hex };
    }

    private get opacity() { return this.layer.opacity; }
    private get opacitySliderValue() { return this.opacity; }
    private set opacitySliderValue(value)
    {
        this.changeLayerProperty(value, "opacity", false);
    }
    private onChangeOpacity(value)
    {
        this.changeLayerProperty(value, "opacity", true);
    }

    private getPropertyValue(propertyName) { return this.layer.inEdit ? this.currentTextInfo[propertyName] : this.getCurrentValueInfo(propertyName).value; }
    private getPropertyBlank(propertyName) { return this.layer.inEdit ? false : this.getCurrentValueInfo(propertyName).isBlank; }

    private get lineSpacing() { return this.layer.lineSpacing; }

    private isHorizontalAlignment(type)
    {
        var result = false;
        if(type == "left")
        {
            result = this.layer.horizontalAlignment == 0;
        }
        else if(type == "center")
        {
            result = this.layer.horizontalAlignment == 1;
        }
        else if(type == "right")
        {
            result = this.layer.horizontalAlignment == 2;
        }
        else if(type == "even")
        {
            result = this.layer.horizontalAlignment == 3;
        }
        return result;
    }

    private isVerticalAlignment(type)
    {
        var result = false;
        if(type == "top")
        {
            result = this.layer.verticalAlignment == 0;
        }
        else if(type == "center")
        {
            result = this.layer.verticalAlignment == 1;
        }
        else if(type == "bottom")
        {
            result = this.layer.verticalAlignment == 2;
        }
        return result;
    }

    private get isTextOrientationVertical() { return this.layer.textOrientation == 1; }
    private setTextOrientation(orientation)
    {
        // 文字方向切り替え
        var value = orientation == "vertical" ? 1 : 0;
        this.changeLayerProperty(value, "textOrientation", true, true);
    }

    //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
    //TODO Props
    openStatus = {
        opend: true
    };

    textTransformContentsOpenAnimate = false;
    textTransformContentsCloseAnimate = false;

    open() {
        if (this.openStatus.opend) {
        this.textTransformContentsCloseAnimate = true;
        setTimeout(() => {
            this.textTransformContentsCloseAnimate = false;
            this.textTransformContentsOpenAnimate = false;
            this.openStatus.opend = false;
        }, 200);
        } else {
        this.openStatus.opend = true;
        this.textTransformContentsOpenAnimate = true;
        setTimeout(() => {
            this.textTransformContentsOpenAnimate = false;
        }, 250);
        }
    }
    //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

    //↓↓↓↓↓チェックボックスのアニメーション↓↓↓↓↓
    private get autoSize()
    {
        return this.layer.autoSize;
    }
    private autoSizeChange() {
        var newValue = this.layer.autoSize == true ? false : true;
        this.changeLayerProperty(newValue, "autoSize", true, true);
    }

    private get autoNewLine()
    {
        return this.layer.autoNewLine;
    }

    private autoNewLineChange()
    {
        var newValue = this.layer.autoNewLine == true ? false : true;
        this.changeLayerProperty(newValue, "autoNewLine", true, true);
    }

    private get bold()
    {
        // 編集中はカレント位置から
        if(this.layer.inEdit) { return this.currentTextInfo.bold; }
        // 非編集中
        // すべてbold : true
        // それ以外 : false
        if(this.layer.textInfoArray.length == 0)
        {
            return this.layer.baseTextInfo.bold;
        }
        else
        {
            var bold = true;
            for(var info of this.layer.textInfoArray)
            {
                if(!info.bold)
                {
                    bold = false;
                    break;
                }
            }
            return bold;
        }
    }

    private boldChange()
    {
        this.changeTextInfo(!this.bold, "bold", true);
    }

    private get italic()
    {
        // 編集中はカレント位置から
        if(this.layer.inEdit) { return this.currentTextInfo.italic; }
        // 非編集中
        // すべてitalic : true
        // それ以外 : false
        if(this.layer.textInfoArray.length == 0)
        {
            return this.layer.baseTextInfo.italic;
        }
        else
        {
            var italic = true;
            for(var info of this.layer.textInfoArray)
            {
                if(!info.italic)
                {
                    italic = false;
                    break;
                }
            }
            return italic;
        }
    }

    private italicChange()
    {
        this.changeTextInfo(!this.italic, "italic", true);
    }

    private get underline()
    {
        // 編集中はカレント位置から
        if(this.layer.inEdit) { return this.currentTextInfo.underline; }
        // 非編集中
        // すべてunderline : true
        // それ以外 : false
        if(this.layer.textInfoArray.length == 0)
        {
            return this.layer.baseTextInfo.underline;
        }
        else
        {
            var underline = true;
            for(var info of this.layer.textInfoArray)
            {
                if(!info.underline)
                {
                    underline = false;
                    break;
                }
            }
            return underline;
        }
    }

    private underlineChange()
    {
        this.changeTextInfo(!this.underline, "underline", true);
    }

    private get isEmQuad()
    {
        // 編集中はカレント位置から
        if(this.layer.inEdit) { return this.currentTextInfo.isEmQuad; }
        // 非編集中
        // すべてisEmQuad : true
        // それ以外 : false
        if(this.layer.textInfoArray.length == 0)
        {
            return this.layer.baseTextInfo.isEmQuad;
        }
        else
        {
            var isEmQuad = true;
            for(var info of this.layer.textInfoArray)
            {
                if(!info.isEmQuad)
                {
                    isEmQuad = false;
                    break;
                }
            }
            return isEmQuad;
        }
    }

    private isEmQuadChange()
    {
        this.changeTextInfo(!this.isEmQuad, "isEmQuad", true);
    }

    private get isHorizontalInVertical()
    {
        // 編集中はカレント位置から
        if(this.layer.inEdit) { return this.currentTextInfo.isHorizontalInVertical; }
        // 非編集中
        // すべてisHorizontalInVertical : true
        // それ以外 : false
        if(this.layer.textInfoArray.length == 0)
        {
            return this.layer.baseTextInfo.isHorizontalInVertical;
        }
        else
        {
            var isHorizontalInVertical = true;
            for(var info of this.layer.textInfoArray)
            {
                if(!info.isHorizontalInVertical)
                {
                    isHorizontalInVertical = false;
                    break;
                }
            }
            return isHorizontalInVertical;
        }
    }

    private isHorizontalInVerticalChange()
    {
        this.changeTextInfo(!this.isHorizontalInVertical, "isHorizontalInVertical", true);
    }

    private get prefix() { return this.layer.prefix; }

    private onSetPrefix(value, isFinish)
    {
        if(isFinish)
        {
            this.changeInputMode(0);
        }
        else
        {
            this.changeInputMode(1);
        }
        this.changeLayerProperty(value, "prefix", isFinish);
    }

    private get suffix() { return this.layer.suffix; }

    private onSetSuffix(value, isFinish)
    {
        if(isFinish)
        {
            this.changeInputMode(0);
        }
        else
        {
            this.changeInputMode(1);
        }
        this.changeLayerProperty(value, "suffix", isFinish);
    }

    //↑↑↑↑↑チェックボックスのアニメーション↑↑↑↑↑

    // カラーピッカー表示非表示
    isColorPickerVisible = false;
    showColorPicker() {
        this.isColorPickerVisible = true;
    }
    closeColorPicker() {
        this.isColorPickerVisible = false;
    }

    // 色変更中
    private onChangingColor(color)
    {
        this.changeTextInfo(color, "textColor", false);
    }

    // 色変更完了
    private onChangedColor(color)
    {
        this.changeTextInfo(color, "textColor", true);
    }

    // controller
    private setHorizontalAlignment(type)
    {
        var newAlignment = this.layer.horizontalAlignment;

        if(type == "left") { newAlignment = 0; }
        else if(type == "center") { newAlignment = 1; }
        else if(type == "right") { newAlignment = 2; }
        else if(type == "even") { newAlignment = 3; }

        if(newAlignment != this.layer.horizontalAlignment)
        {
            this.changeLayerProperty(newAlignment, "horizontalAlignment", true, true);
        }
    }

    private setVerticalAlignment(type)
    {
        var newAlignment = this.layer.verticalAlignment;

        if(type == "top") { newAlignment = 0; }
        else if(type == "center") { newAlignment = 1; }
        else if(type == "bottom") { newAlignment = 2; }

        if(newAlignment != this.layer.verticalAlignment)
        {
            this.changeLayerProperty(newAlignment, "verticalAlignment", true, true);
        }
    }

    // ValueEdit
    // テキスト固有の値変更
    private onChangingTextValue(value : number, tag : string)
    {
        this.changeTextInfo(value, tag, false);
    }

    private onChangedTextValue(value : number, tag : string)
    {
        this.changeTextInfo(value, tag, true);
    }

    // レイヤー全体の値変更
    private onChangingLayerValue(value, tag)
    {
        this.changeLayerProperty(value, tag, false);
    }

    private onChangedLayerValue(value, tag)
    {
        this.changeLayerProperty(value, tag, true);
    }

    private changeTextInfo(value : any, propertyName : string, isFinish : boolean = false, isOnce : boolean = false)
    {
        this.$emit("doCommand", "changePlainTextLayerWholeTextInfo", {
            layer : this.layer,
            propertyName : propertyName,
            value : value,
            isFinish : isFinish,
            isOnce : isOnce
        });
    }


    private changeLayerProperty(value : any, propertyName : string, isFinish : boolean = false, isOnce : boolean = false)
    {
        this.$emit("doCommand", "changeLayerProperty", {
            layer : this.layer,
            propertyName : propertyName,
            value : value,
            isFinish : isFinish,
            isOnce : isOnce
        });
    }

    private get textTransformOpendStyle(){
        var style = {};
        if(this.applicationState.flowMode != 0 && this.openStatus.opend){
            style = {
                height: "calc(593% / 752 * 100) !important"
            };
        }
        return style;
    }

    private get commonGroupStyle(){
        var style = {};
        if(this.applicationState.flowMode != 0){
            style = {
                height: "7.23%"
            };
        }
        return style;
    }

    private get buttonGroupStyle(){
        var style = {};
        if(this.applicationState.flowMode != 0){
            style = {
                height: "9.02%"
            };
        }
        return style;
    }

    private get applicationState(){
        return this.$store.getters.applicationState;
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    private getFontFamily(fontId : string)
    {
        var fontManager : FontManager = this.$store.getters.fontManager;
        return fontManager.getFontFamilyName(fontId);
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
